module.exports = __webpack_public_path__ + "static/carbon-mobile-40605b6fa706ad04c51dd14ddddb8bfc.webm";